export const encodePercent = (keyword: string) => {
  if (!keyword) return ''

  return keyword.replace(/[%]/gi, '%25')
}

export const decodeString = (str: string) => {
  try {
    return decodeURIComponent(str)
  } catch (e) {
    return str
  }
}
